"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getProductsQuery = require("./getProductsQuery");
Object.keys(_getProductsQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getProductsQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getProductsQuery[key];
    }
  });
});
